var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 40,
    maskUnits: "userSpaceOnUse",
    width: 40,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#e7ecf2",
    r: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    fill: "#e7ecf2",
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#96a2b7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 25c3.5899 0 6.5-2.9101 6.5-6.5s-2.9101-6.5-6.5-6.5-6.5 2.9101-6.5 6.5 2.9101 6.5 6.5 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 26.625c-7.6375 0-13 4.0625-13 9.75v7.625h26v-7.625c0-5.6875-5.3625-9.75-13-9.75z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/user-profile-icon.b27b4316.svg";
export { ForwardRef as ReactComponent };